import React from "react";

// Chip numero sezione + titolo. `center` per allineare al centro (senza linea).
export default function SectionHead({ index, title, className = "", center = true }) {
  return (
    <div className={className} style={center ? { textAlign: "center" } : undefined}>
      <div className="numhead" style={center ? { justifyContent: "center" } : undefined}>
        <span className="numchip">{index}</span>
        {!center && <span className="numline" />}
      </div>
      <h2 className="display sec-title">
        {title}
      </h2>
    </div>
  );
}
